import React from 'react';
import PropTypes from 'prop-types';
import { STATS } from '../../config/stats';
import { useSelector } from 'react-redux';
import {
    competitionSelector,
    seasonSelector,
    roundSelector
} from '../../../../../../store/js/modules/statspro/stats-leaders/selectors';

/**
 * @param {object} props - Props.
 * @param {string} props.sortedColumnId - The column ID.
 * @param {'ascending'|'descending'} props.sortDirection - The sort direction.
 * @returns {JSX.Element} Component.
 */
export const TableCaption = ( {
    sortedColumnId,
    sortDirection
} ) => {
    const competition = useSelector( competitionSelector );
    const season = useSelector( seasonSelector );
    const round = useSelector( roundSelector );

    const sortedColumnName = STATS[ sortedColumnId ].name;
    
    return (
        <caption className="u-screen-reader">
            { competition.name } players ranked by { sortedColumnName } ({ sortDirection })
            { round ?
                ` for ${ round.name } of the ${ season.name } season.` :
                ` for the ${ season.name } season.`
            }
        </caption>
    );
};

TableCaption.propTypes = {
    sortedColumnId: PropTypes.string.isRequired,
    sortDirection: PropTypes.oneOf( [ 'ascending', 'descending' ] )
};